export default ['.delfi.lt', '.delfi.net'];
